/**
 * Redux action types for "boards"
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
export const BEGIN_FETCH_BOARDS = 'BEGIN_FETCH_BOARDS'
export const FETCH_BOARDS_SUCCESS = 'FETCH_BOARDS_SUCCESS'
export const FETCH_BOARDS_ERROR = 'FETCH_BOARDS_ERROR'
export const BEGIN_CREATE_BOARD = 'BEGIN_CREATE_BOARD'
export const CREATE_BOARD_SUCCESS = 'CREATE_BOARD_SUCCESS'
export const DELETE_BOARD_SUCCESS = 'DELETE_BOARD_SUCCESS'

export const FETCH_BOARD_NOTES_SUCCESS = 'FETCH_BOARD_NOTES_SUCCESS'
export const FETCH_BOARD_NOTES_ERROR = 'FETCH_BOARD_NOTES_ERROR'
export const UPDATE_BOARD_NOTES = 'UPDATE_BOARD_NOTES'
export const UPDATE_BOARD_NOTES_ERROR = 'UPDATE_BOARD_NOTES_ERROR'

export const FETCH_BOARD_SUCCESS = 'FETCH_BOARD_SUCCESS'
export const FETCH_PUBLIC_BOARD_SUCCESS = 'FETCH_PUBLIC_BOARD_SUCCESS'
export const BEGIN_FETCH_PUBLIC_BOARD_DETAILS = 'BEGIN_FETCH_PUBLIC_BOARD_DETAILS'
export const FETCH_PUBLIC_BOARD_DETAILS_SUCCESS = 'FETCH_PUBLIC_BOARD_DETAILS_SUCCESS'
export const CREATE_LIST = 'CREATE_LIST'
export const BEGIN_UPDATE_LIST_ORDER = 'BEGIN_UPDATE_LIST_ORDER'
export const COMMIT_UPDATE_LIST_ORDER = 'COMMIT_UPDATE_LIST_ORDER'
export const FETCH_BOARD_PHOTOS = 'FETCH_BOARD_PHOTOS'
export const DELETE_PHOTOS = 'DELETE_PHOTOS'

export const FETCH_COLLABORATORS = 'FETCH_COLLABORATORS'
export const ADD_COLLABORATOR = 'ADD_COLLABORATOR'
export const INVITE_COLLABORATOR_WITH_EMAIL = 'INVITE_COLLABORATOR_WITH_EMAIL'
export const UNINVITE_COLLABORATOR = 'UNINVITE_COLLABORATOR'
export const UPDATE_COLLABORATOR_ROLE = 'UPDATE_COLLABORATOR'
export const DELETE_COLLABORATOR = 'DELETE_COLLABORATOR'

export const FOLLOW_BOARD = 'FOLLOW_BOARD'
export const UNFOLLOW_BOARD = 'UNFOLLOW_BOARD'
export const DELETE_BOARD_FOLLOW = 'DELETE_BOARD_FOLLOW'

export const UPDATE_BOARD = 'UPDATE_BOARD'
export const UPDATE_BOARD_SUCCESS = 'UPDATE_BOARD_SUCCESS'
export const UPDATE_BOARD_ERROR = 'UPDATE_BOARD_ERROR'
export const UPDATE_BOARD_SETTINGS = 'UPDATE_BOARD_SETTINGS'

export const RECEIVE_UPDATE_LIST = 'RECEIVE_UPDATE_LIST'
export const RECEIVE_UPDATE_PLACE = 'RECEIVE_UPDATE_PLACE'
export const COLLABORATOR_UPDATE_BOARD = 'COLLABORATOR_UPDATE_BOARD'
export const COLLABORATOR_UPDATE_LIST = 'COLLABORATOR_UPDATE_LIST'
export const COLLABORATOR_UPDATE_PLACE = 'COLLABORATOR_UPDATE_PLACE'

export const FETCH_SUGGESTIONS_FOR_USER_AND_BOARD_SUCCESS = 'FETCH_SUGGESTIONS_FOR_USER_AND_BOARD_SUCCESS'
export const FETCH_SUGGESTIONS_FOR_USER_AND_BOARD_ERROR = 'FETCH_SUGGESTIONS_FOR_USER_AND_BOARD_ERROR'
export const FETCH_SEARCH_SUGGESTIONS_FOR_BOARD_SUCCESS = 'FETCH_SEARCH_SUGGESTIONS_FOR_BOARD_SUCCESS'
export const FETCH_SEARCH_SUGGESTIONS_FOR_BOARD_ERROR = 'FETCH_SEARCH_SUGGESTIONS_FOR_BOARD_ERROR'

export const UPDATE_BACKGROUND_PHOTO = 'UPDATE_BACKGROUND_PHOTO'
export const UPDATE_PLACE_BACKGROUND_PHOTO = 'UPDATE_PLACE_BACKGROUND_PHOTO'
export const UPDATE_PLACE_PHOTO_LINKS = 'UPDATE_PLACE_PHOTO_LINKS'

export const ADD_BOARD_TAG = 'ADD_BOARD_TAG'
export const DELETE_BOARD_TAG = 'DELETE_BOARD_TAG'
